import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";

export const ServicesContainter = styled.div`
  @media screen and (min-width: 320px) {
    height: 1550px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
  }

  @media screen and (min-width: 481px) {
    height: 1000px;
  }

  @media screen and (min-width: 768px) {
    height: 800px;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
  }
`;

export const ServicesWrapper = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }

  @media screen and (max-width: 481px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const ServicesCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media screen and (min-width: 320px) {
    /* height: 290px; */
  }
  @media screen and (min-width: 641px) {
    height: 400px;
  }
`;

export const ServicesIcon = styled.img`
  height: 180px;
  /* height: 200px; */
  width: 100%;
  margin-bottom: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media screen and (min-width: 320px) {
    /* height: 150px;
    width: 100%; */
  }

  @media screen and (min-width: 641px) {
    height: 200px;
    width: 100%;
  }
`;

export const ServicesTextContainer = styled.div`
  text-align: center;
  padding: 0 10px 10px 10px;
`;

export const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1 rem;
  margin-bottom: 10px;
`;

export const ServicesP = styled.p`
  text-align: center;

  @media screen and (min-width: 320px) {
    font-size: 0.8rem;
  }
  @media screen and (min-width: 641px) {
    font-size: 0.95rem;
  }
`;

export const ServicesPopupTitle = styled.h2`
  text-align: center;
`;

export const ServicesPopupDescription = styled.p`
  font-size: 1rem;
  text-align: center;
`;

export const NavLinksRouter = styled(LinkR)``;

export const ServicesPopupDinnerDescription = styled.div`
  display: grid;

  ul {
    list-style-type: circle;
  }

  ul li {
    margin-left: 15px;
    line-height: 22px;
    padding: 10px 0 10px 0;
  }

  ul h3 {
    text-align: center;
    padding-bottom: 10px;
  }

  @media screen and (min-width: 320px) {
    ul {
      font-size: 0.8rem;
    }
  }

  @media screen and (min-width: 768px) {
    ul {
      font-size: 1rem;
    }
  }
`;

export const ServicesPopupBbqDescription = styled.div`
  font-size: 1rem;
  display: grid;

  ul {
    list-style-type: circle;

    display: grid;
    /* grid-template-rows: repeat(4, min-content);
    grid-auto-flow: column; */
  }

  ul li {
    margin-left: 15px;
    /* width: 200px; */
    line-height: 22px;
    padding: 10px 0 10px 0;
  }

  ul h3 {
    text-align: center;
    padding-bottom: 10px;
  }

  @media screen and (min-width: 320px) {
    grid-template-columns: 1fr;

    p {
      text-align: center;
    }

    ul {
      list-style-type: circle;
    }
  }

  @media screen and (min-width: 768px) {
    ul {
      grid-template-rows: repeat(4, min-content);
      grid-auto-flow: column;
    }
  }
`;

export const ServicesPopupListContainer = styled.div`
  border: solid 2px #d6d6d6;
  padding: 10px;
  margin: 10px 32px;

  h3 {
    text-align: center;
    padding-bottom: 10px;
  }
`;

export const ServicesPopupDisclaimer = styled.div`
  text-align: center;
  font-size: 12px;
`;
